module.exports = __webpack_public_path__ + "202408221624/img/img_spiny_54_8@2x.4ac4b4eb.png";